//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        current_question: Object
    },
    methods: {
        selectOpt(item) {
            this.$emit('selectOpt', {
                ...item,
                question_content: this.current_question.content,
                qid: this.current_question.qid
            })
        },
        toggleFold(i) {
            this.$emit('toggleFold',i)
        }
    },
}
